import { render, staticRenderFns } from "./DoctorsPending.html?vue&type=template&id=0193aa2e&external"
import script from "./DoctorsPending.vue?vue&type=script&lang=js"
export * from "./DoctorsPending.vue?vue&type=script&lang=js"
import style0 from "./DoctorsPending.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports